<template>
    <section>
        <div>
            <div class="content-header">
                <div class="content-header-left mb-2">
                    <div class="breadcrumbs-top">
                        <h2 class="content-header-title mb-0">{{ title }} </h2>
                        <div class="breadcrumb-wrapper">
                            <slot name="breadcumb"></slot>
                        </div>
                    </div>
                </div>
            </div>

            <!-- tools filter -->
            <div v-if="$slots['header-tools']">
                <slot name="header-tools"></slot>
            </div>
            <!-- end tools filter -->

            <!-- actions -->
            <div class="card" v-if="$slots['action']">
                <div class="card-content">
                    <div class="card-body card-dashboard">
                        <slot name="action"></slot>
                    </div>
                </div>
            </div>
            <!-- actions end -->

            <!-- content -->
            <div>
                <slot name="content"></slot>
            </div>
            <!-- end content -->
        </div>

    </section>
</template>

<script> 
export default {
    props: [ 'title' ]
}
</script>